import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'src/app/services/toast-service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(
        private toastr: ToastrService,
        private router: Router,
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const excludeUrls = ['api/account/login'];
        const token = localStorage.getItem('accessToken');

        // Skip interceptor for excluded URLs
        if (excludeUrls.some(url => req.url.toLowerCase().includes(url.toLowerCase()))) {
            return next.handle(req);
        }

        // Clone request if token exists
        const modifiedReq = token
            ? req.clone({
                headers: req.headers.set('Authorization', `Bearer ${token}`)
            })
            : req;

        return next.handle(modifiedReq).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401 || error.status === 403) {
                    // Avoid re-navigating to login if already there
                    if (this.router.url !== '/login') {
                        localStorage.removeItem('accessToken');
                        localStorage.removeItem('userType');
                        localStorage.setItem('sessionExpired', 'true');
                        this.toastr.error('Session expired. Please log in again.');
                        this.router.navigate(['/login']);
                    }
                }

                return throwError(() => error);
            })
        );
    }
}
